export default [
  {
    key: 'actions',
    sortable: false,
    visible: true
  },
  {
    key: 'date',
    sortable: true,
    visible: true
  },
  {
    key: 'amount',
    sortable: true,
    visible: true
  },
  {
    key: 'account_used',
    sortable: true,
    visible: true
  },
  {
    key: 'description',
    visible: true
  },
  {
    key: 'category',
    sortable: false,
    visible: true
  },
  {
    key: 'primary_source',
    label: 'Sub Category',
    sortable: true,
    visible: true
  },
  {
    key: 'recurring',
    sortable: true,
    visible: true
  }
];